<template>
  <div class="keyboard">

    <keyboardContact/>

  </div>
</template>

<script>
import keyboardContact from '@/components/keyboardContact.vue'


export default {

  name : 'ClavierView',

  components : {

      keyboardContact,
  }, 

  

 
  
};
</script>

<style scoped>

</style>